import { render, staticRenderFns } from "./ContentDialog.vue?vue&type=template&id=3347b624"
import script from "./ContentDialog.vue?vue&type=script&lang=js"
export * from "./ContentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports